export enum CarouselTheme {
  DEFAULT = 'default',
  HAS_BACKGROUND = 'has-background',
}
